export const brokerDealerAccessState = {
    notInvited: 1,
    accessRequested: 2,
    approved: 3,
    rejected: 4
};
